'use client';

import { IAppExtended, ILayout } from '@websolutespa/bom-core';
import React from 'react';
import { createGenericContext } from '../useGenericContext/useGenericContext';

export type ILayoutContext = ILayout;

const [useLayout_, LayoutContextProvider] = createGenericContext<ILayoutContext>();

function LayoutProvider({ children, layout }: { children?: React.ReactNode, layout: ILayout }) {
  // console.log('LayoutProvider.context', context);
  return (
    <LayoutContextProvider value={layout}>
      {children}
    </LayoutContextProvider>
  );
}

type UseLayout = <T extends IAppExtended = IAppExtended>() => ILayout<T>;

const useLayout:UseLayout = useLayout_ as UseLayout;

export {
  LayoutProvider,
  useLayout
};

